import { render, staticRenderFns } from "./ApproveTags.vue?vue&type=template&id=5d64d8e3&scoped=true"
import script from "./ApproveTags.vue?vue&type=script&lang=js"
export * from "./ApproveTags.vue?vue&type=script&lang=js"
import style0 from "./ApproveTags.vue?vue&type=style&index=0&id=5d64d8e3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d64d8e3",
  null
  
)

export default component.exports